/**
 * Push data to Google Tag Manager to display in Google Analytics
 *
 * @param {object} data Json data to send
 */
export const sendDataToGa4 = ( data ) => {

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);

}
